import { Params } from '@angular/router';
import { StepModel, AppStepIndicatorItemViewModel } from '@classifieds-sell/shared';

export interface IRouterState {
    id: number;
    url: string;
    fullUrl: string;
    params: Params;
    queryParams: Params;
    data: IRouterData;
    fragment: string;
}

export interface IRouterData {
    categoryId?: number;
    stepInfo?: StepInfo;
    subCategory?: string;
    steps?: StepModel[];
    agent?: boolean;
    editing?: boolean;
    relisting?: boolean;
}

export interface StepInfo {
    stepId?: string;
    step?: AppStepIndicatorItemViewModel;
    nextStepId?: string;
    nextStep?: AppStepIndicatorItemViewModel;
    prevStepId?: string;
    prevStep?: AppStepIndicatorItemViewModel;
}
